module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pjkuiT/tc-custom/9781955835350.jpg?1716521184902",
      "alt": "This image is the cover for the book Turkey's Modernization"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Turkey's Modernization\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This historical study examines the lives of European Jews who found safe haven in Turkey and helped the nation transform in the years before WWII.")]), _c('br'), _c('br'), _vm._v("Out of the ashes of the Ottoman Empire, Mustafa Kemal Ataturk formed the modern Republic of Turkey. As the nation’s founding father and first president, he initiated numerous progressive reforms. In 1933, he welcomed German and Austrian Jews who fled the rise of antisemitic violence in their homelands. In "), _c('i', [_vm._v("Turkey’ Modernization")]), _vm._v(", historian Arnold Reisman chronicles the lives of some of these refugees as they pursued new lives in a new nation."), _c('br'), _c('br'), _vm._v("Using archival documents, letters, memoirs, oral histories, photos, and other surviving evidence, Arnold Reisman sheds light on courage and determination of these individuals, as well as their important contributions in several fields of knowledge. With a clear-eyed analysis of Turkey’s achievements and shortcomings, Reisman also speculates about its inability to fully capitalize on these emigres’ legacy."), _c('br'), _c('br'), _c('b', [_vm._v("“This book adds to our knowledge of an important aspect of the Holocaust, and of the behavior of Nation States in the modern world of woe and grief.” —Sir Martin Gilbert, Winston Churchill’s official biographer ")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Arnold Reisman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Academia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0